import { useEffect, useState } from 'react';

import { Alert } from '@components/Alert';
import { Document, LocalFile } from '@graphql/generated';

const DEFAULT_MAX_SELECTABLE = 25;

export const useDocumentSelection = (
  maxSelectable: number = DEFAULT_MAX_SELECTABLE
) => {
  const [isSelectMode, setIsSelectMode] = useState(false);
  const [selectedDocuments, setSelectedDocuments] = useState<
    Array<Document | LocalFile>
  >([]);

  useEffect(() => {
    if (selectedDocuments?.length === 0) {
      setIsSelectMode(false);
    }
  }, [selectedDocuments]);

  const toggleSelectItem = (item: Document | LocalFile) => {
    setSelectedDocuments((prev) => {
      const item0 = prev?.find((item2) => {
        return item2.id === item.id;
      });
      if (item0) {
        return prev.filter((item3) => item3.id !== item.id);
      } else if (prev.length < maxSelectable) {
        return [...prev, item];
      } else {
        Alert.alert(
          `Maximum ${maxSelectable} files can be selected at a time.`
        );
        return prev;
      }
    });
  };

  const clearSelection = () => {
    setIsSelectMode(false);
    setSelectedDocuments([]);
  };

  return {
    isSelectMode,
    setIsSelectMode,
    selectedDocuments,
    setSelectedDocuments,
    toggleSelectItem,
    clearSelection,
  };
};
